module.exports = __webpack_public_path__ + "static/media/fins.b6c32858.png";